import { SvgIcon as MuiSvgIcon } from "@material-ui/core";
import { ComponentProps } from "react";
import { Color } from "../../theme/color";

export function FavoriteIcon(props: ComponentProps<typeof MuiSvgIcon>) {
  return (
    <MuiSvgIcon viewBox="0 0 13 13" htmlColor={Color.Gray} {...props}>
      <path d="M6.421 10.58a1 1 0 0 1-.322-.058.76.76 0 0 1-.285-.18l-.718-.653A33 33 0 0 1 2.72 7.306Q1.675 6.136 1.675 4.8q0-1.065.718-1.782T4.175 2.3q.605 0 1.195.279t1.055.906q.465-.627 1.056-.906A2.8 2.8 0 0 1 8.676 2.3q1.065 0 1.783.718.717.718.717 1.782 0 1.35-1.062 2.534a32 32 0 0 1-2.37 2.362l-.71.646a.76.76 0 0 1-.288.18 1 1 0 0 1-.325.058" />
    </MuiSvgIcon>
  );
}
export default FavoriteIcon;
